module.exports = __webpack_public_path__ + "static/media/YF08_0.f21e05e1.jpg";